import { actionTypes} from '../actions/currencies'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes)
